<template>
    <div>
        <div>{{ titulo }}</div>
        <div class="mt-1 mb-1">
            <span v-if="dado">
                <strong v-if="tipo == null">{{ dado }}</strong>
                <strong v-if="tipo == 'datetime'">{{ $moment(dado).format('DD/MM/YYYY HH:mm') }}</strong>
                <strong v-if="tipo == 'date'">{{ $moment(dado).format('DD/MM/YYYY') }}</strong>
            </span>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
	name: 'DetalheFormComponent',
	props: {
		titulo: {
			type: String,
			default: ''
		},

		dado: {
			type: String,
			default: ''
		},

		tipo: {
			type: String,
			default: null
		}
	}
}
</script>
